import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card, Icon } from '@mui/material';
import VuiBox from 'components/ui/VuiBox';
import VuiTypography from 'components/ui/VuiTypography';
import VuiButton from 'components/ui/VuiButton';
import { IoShieldHalf } from 'react-icons/io5';
import { authService, jwtService } from "services";
import { GRADIENTS } from "utils/designTokens";

const AccessDenied = () => {
  const history = useHistory();
  const userInfo = jwtService.getUserInfo();

  const handleLogout = async () => {
    await authService.logout();
    history.push('/authentication/sign-in');
  };

  return (
    <VuiBox
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        background: GRADIENTS.pageBg,
        padding: '2rem'
      }}
    >
      <Card
        sx={{
          maxWidth: '500px',
          width: '100%',
          background: 'linear-gradient(127.09deg, rgba(6, 11, 40, 0.94) 19.41%, rgba(10, 14, 35, 0.69) 76.65%)',
          borderRadius: '20px',
          padding: '2rem',
          boxShadow: '0 20px 27px 0 rgb(0 0 0 / 5%)'
        }}
      >
        <VuiBox display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <IoShieldHalf size="60px" color="#f53939" />

          <VuiTypography variant="h3" color="white" fontWeight="bold" mt={3}>
            Access Denied
          </VuiTypography>

          <VuiTypography variant="body2" color="text" fontWeight="regular" mt={2}>
            You don't have the required permissions to access this area.
            This section requires the 'client' role for access.
          </VuiTypography>

          {userInfo && (
            <VuiBox mt={3} mb={2}>
              <VuiTypography variant="button" color="text" fontWeight="medium">
                Current user: {userInfo.username}
              </VuiTypography>
              <VuiTypography variant="button" color="text" display="block" fontWeight="medium">
                Roles: {userInfo.roles?.join(', ') || 'None'}
              </VuiTypography>
            </VuiBox>
          )}

          <VuiBox display="flex" mt={3} justifyContent="center" width="100%">
            <VuiButton
              color="info"
              variant="contained"
              onClick={() => history.push('/')}
              sx={{ mr: 1 }}
            >
              <Icon sx={{ fontWeight: "bold", mr: "5px" }}>home</Icon>
              Go to Dashboard
            </VuiButton>

            <VuiButton
              color="error"
              variant="contained"
              onClick={handleLogout}
            >
              <Icon sx={{ fontWeight: "bold", mr: "5px" }}>logout</Icon>
              Logout
            </VuiButton>
          </VuiBox>
        </VuiBox>
      </Card>
    </VuiBox>
  );
};

export default AccessDenied;